/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import React from "react";

import {
	BackgroundContainer,
	ButtonList,
	ResponsiveContainer,
	SectionContainer,
	TitleDescStack,
} from "@components/elements";

import { CosmosEnumEdsGradients, CosmosModButtonFragment, HeroBravoFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { VideoShade } from "./HeroBravo.VideoShade";
import { useBgVideo } from "@components/hooks/asset.hooks";

export interface HeroBravoProps {
	backgroundAsset?: HeroBravoFragment["backgroundAsset"];
	title?: HeroBravoFragment["title"];
	desc?: HeroBravoFragment["desc"];
	buttons?: HeroBravoFragment["buttons"];
	modButtons?: CosmosModButtonFragment[] | null;
	gradient?: CosmosEnumEdsGradients | null;
}

export const HeroBravo = ({
	backgroundAsset,
	title,
	desc,
	buttons,
	modButtons,
	gradient,
}: HeroBravoProps): React.JSX.Element => {
	const { isBgVideo, background } = useBgVideo(backgroundAsset, true);

	const buttonSource = modButtons?.length ? modButtons : buttons;

	return (
		<BackgroundContainer
			bgImageAsset={!isBgVideo ? backgroundAsset : undefined}
			bgFullHeight={true}
			className={css({
				position: "relative",
			})}
			style={{ background }}
		>
			{isBgVideo && backgroundAsset ? <VideoShade asset={backgroundAsset} /> : null}
			<ResponsiveContainer zIndex="2" h="100%">
				<SectionContainer
					height="100%"
					display="flex"
					alignItems="center"
					minHeight="500px"
					className={css({ "&&": { smDown: { minHeight: "auto" } } })}
				>
					<VStack alignItems="start" gap="eds.dimension.32" width="100%" maxWidth="410px" className={cx("hero-bravo")}>
						{title || desc ? (
							<TitleDescStack
								stack={{ gap: "eds.dimension.16" }}
								title={{
									...title,
									as: "h1",
									variant: "heading2XL",
								}}
								gradient={gradient}
								description={{ html: desc, color: "eds.text.primary" }}
							/>
						) : null}
						{buttonSource?.length ? <ButtonList buttons={buttonSource} size="lg" /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
